import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "About the Site",
description: "Technical details about how the Freon documentation website was built, including SvelteKit, EmbedMe, mdsvex, Prism, and other supporting tools and resources.",
tags: [ "Freon", "website", "SvelteKit", "EmbedMe", "mdsvex", "Prism", "documentation site", "Visual Studio Code theme", "Flaticon", "word cloud", "tools", "credits"] ,
modifiedTime: "2025-11-07T17:20:18.649Z",
publishedTime: "2025-11-07T17:20:18.649Z"
    }
  };
};